module.exports = __webpack_public_path__ + "img/file.380d42ca.png";